import React from 'react'
import PropTypes from 'prop-types'
import RichText from '../RichText'

import { convertMarkdown } from './parsers'
import styles from './index.module.scss'

const Table = ({ content, caption, variant, title }) => {
  if (!content || !content.length) return null

  const styleClass = `${variant.split(' ').join('-').toLowerCase()}-table`

  return (
    <div data-testid="table" className="grid">
      {title ? (
        <h2 className="mb-4 text-2xl leading-8" id={title}>
          {title}
        </h2>
      ) : null}
      <div className={`${styles.table} ${styles[styleClass] ?? ''}`}>
        {convertMarkdown(content)}
        <RichText content={caption} className={`text-xs`} />
      </div>
    </div>
  )
}

Table.defaultProps = {
  title: '',
  variant: 'Plain',
  caption: {},
}
Table.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  content: PropTypes.string.isRequired,
  caption: PropTypes.object,
}
export default Table
